import {getSite} from 'src/utils/selectors';

/**
 * Send an event to Google Analytics if gtag is available.
 * @param {string} eventName - The name of the event.
 * @param {object} params - Additional event parameters.
 */
const sendGAEvent = (eventName, params = {}) => {
	if (typeof window !== 'undefined' && typeof window.gtag !== 'undefined') {
		try {
			window.gtag('event', eventName, {
				...params,
				site: getSite()?.id,
			});
		} catch (err) {
			console.error('Error sending GA event:', err);
		}
	} else {
		console.warn('Google Analytics not initialized');
	}
};

export default sendGAEvent;
